import React, {useEffect, useState} from "react";
import MDInput from "../../../components/MDInput";
import {useForm} from "react-hook-form";
import {handleDefaultValues} from "../../common/Utils";
import {InputAdornment} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MDButton from "../../../components/MDButton";
import {applyDiscountCode} from "../../common/api/CartApi";

export default function CartDiscountCode({cart, callback}) {

  const [active, setActive] = useState(false);
  const [working, setWorking] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSave = (formData) => {
    console.dir(formData);
    setWorking(true)
    applyDiscountCode(formData).then((resp)=>{
      callback()
    }).catch((err)=>{
      setErrorMessage(err?.response?.data?.message || 'Invalid discount code');
      setWorking(false);
    })
  }

  const [discountCode, setDiscountCode] = useState('');

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues({})
  });

  useEffect(()=>{
    setValue('code', cart.appliedDiscountCode);
    setDiscountCode(cart?.appliedDiscountCode);
  },[cart?.hasDiscountCodes]);

  return (
    <>
      {(cart?.showDiscountCodes || cart?.hasDiscountCodes) && <>
        <form className={'my-4'} onSubmit={handleSubmit(handleSave)} id={'discountCodeForm'}>
          <div className="form-group ">
            <MDInput
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <MDButton size={"small"} color={"primary"}
                            disabled={working || cart?.hasDiscountCodes}
                            type={"submit"}>{working ? 'Apply...' : 'Apply'}</MDButton>
                </InputAdornment>
              }}
              variant="outlined" type="text" required
              {...register('code', {
                disabled: cart?.hasDiscountCodes,
              })}
              className="form-control" id="code"
              label={'Enter Discount Code'} />
          </div>
          {errorMessage && <p className={'mt-0'}><small>{errorMessage}</small></p>}
        </form>
      </>}
    </>
  )
}